<!-- No links message -->
<div *ngIf="links?.length == 0 && !isLoading" class="top-text">
  <h4 style="margin-bottom: 20px;">Report doesn't have any Links</h4>
  <button [disabled]="createDeleteFlag" class="btn btn-rbv" (click)="onCreateLink()">Create New Link</button>
</div>

<!-- List of Link -->
<div *ngIf="links?.length > 0 && !isLoading">
  <div class="dashboard">
    <div class="wrapper">
      <!-- Loading-->
      <loader [loading]="isLoading"></loader>

      <div class="row">
        <div [ngClass]="{'col-md-8': currentReport.LINK_ACCESS?.length > 0, 'col-md-12': currentReport.LINK_ACCESS?.length == 0}">
          <!-- List -->
          <div *ngIf="links?.length > 0 && !isLoading" class="reports-data">
            <div class="report" *ngFor="let link of links; let i = index" [ngClass]="{'selected': link.selected}">
              <div class="row">
                <!-- <div class="col-md-7 company">
                  <div class="company-info link-info">
                    <div class="link-type" [ngSwitch]="link.TYPE">
                      <div class="link-type hinted" *ngSwitchCase="LinkType.USER">
                        <fa name="fa fa-user-circle-o"></fa>
                        <div class="hint">User Created</div>
                      </div>

                      <div class="link-type hinted" *ngSwitchCase="LinkType.SYSTEM">
                        <fa name="fa fa-server"></fa>
                        <div class="hint">System Created</div>
                      </div>
                    </div>

                    <a class="company-name" target="_blank"
                      href="{{ link.MODULE_TYPE == ModuleType.BVQ ? hostName + bvqHostPath + link.HASH : hostName + hostPath + link.HASH}}">
                      {{link.HASH}}
                    </a>
                  </div>
                </div> -->

                <div class="col-md-7 company">
                  <div class="company-info link-info">
                    <div class="link-type" [ngSwitch]="link.TYPE">
                      <div class="link-type hinted" *ngSwitchCase="LinkType.USER">
                        <fa name="fa fa-user-circle-o"></fa>
                        <div class="hint">User Created</div>
                      </div>

                      <div class="link-type hinted" *ngSwitchCase="LinkType.SYSTEM">
                        <fa name="fa fa-server"></fa>
                        <div class="hint">System Created</div>
                      </div>
                    </div>

                    <a class="company-name" target="_blank" *ngIf="link.TYPE !== LinkType.ASK_USER"
                      [href]="getTrackerLinkURL(link)">
                      tracker/{{link.ID}}
                    </a>

                    <div class="company-name" target="_blank" *ngIf="link.TYPE === LinkType.ASK_USER">
                      {{link.ID}} ({{link.EMAIL}})
                    </div>
                  </div>
                </div>


                <!-- Date of Expire -->
                <div class="column col-md-3">
                  <div *ngIf="link?.DATE_EXPIRES" class="link-expires">
                    <link-expiration [created]="link.DATE_EXPIRES"></link-expiration>
                  </div>
                </div>

                <div class="column end col-md-1">
                  <div class="modules-container">
                      <div class="module">
                          {{link.MODULE_TYPE == ModuleType.BVQ ? 'BVQ' : 'PMA'}}
                      </div>
                    </div>
                </div>

                <!-- Options -->
                <div class="column end col-md-1 action" *ngIf="!link.selected">

                  <div class="action-wrapper">
                    <span class="copy-popover" *ngIf="link.copied === true">Copied to buffer</span>

                    <button type="button" class="btn btn-default btn-sm sub" ngxClipboard (click)="copy(link)">
                      <fa class="check-block" name="fa fa-clipboard"></fa>
                    </button>
                  </div>

                  <div class="btn-group" dropdown>
                    <button dropdownToggle type="button" class="btn btn-default btn-sm sub">
                      <fa class="check-block" name="fa fa-ellipsis-v"></fa>
                    </button>

                    <div *dropdownMenu class="drop-menu dropdown-menu-right">
                      <!-- <a class="drop-item" (click)="onEditLink(link, i)">
                        <div class="item">Edit Link</div>
                      </a> -->
                      <a class="drop-item" href="{{ link.MODULE_TYPE == ModuleType.BVQ ? hostName + bvqHostPath + link.HASH : hostName + hostPath + link.HASH}}" target="_blank">
                        <div class="item ml-0">Open Link</div>
                      </a>

                      <a *ngIf="!createDeleteFlag" class="drop-item" (click)="onDeleteLink(link, i)">
                        <div class="item ml-0">Delete Link</div>
                      </a>

                      <ng-container *ngIf="link.TYPE === LinkType.ASK_USER">
                        <a class="drop-item" (click)="sendFollowUp(link)" *ngIf="!link.DISABLE_FOLLOWUP">
                          <div class="item ml-0">Send Follow Up</div>
                        </a>

                        <a class="drop-item" (click)="disableEnableFollowUp(link)">
                          <div class="item ml-0">{{!link.DISABLE_FOLLOWUP ? 'Disable' : 'Enable'}} Follow Up</div>
                        </a>
                      </ng-container>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <!-- Button to create new link -->
          <div class="subheader">
            <button [disabled]="createDeleteFlag" class="btn btn-rbv mr-2" (click)="onCreateSupplementalLink()">Create Supplemental Link</button>
            <button [disabled]="createDeleteFlag" class="btn btn-rbv" (click)="onCreateLink()">Create New Link</button>
          </div>
        </div>

        <div class="col-md-4" *ngIf="currentReport.LINK_ACCESS?.length > 0">
          <link-access [report]="currentReport"></link-access>
        </div>
      </div>
    </div>
  </div>
</div>
